__turbopack_context__.v({
  "burger": "header-module-scss-module__4M_j_a__burger",
  "clearfix": "header-module-scss-module__4M_j_a__clearfix",
  "header": "header-module-scss-module__4M_j_a__header",
  "headerActions": "header-module-scss-module__4M_j_a__headerActions",
  "headerBtn": "header-module-scss-module__4M_j_a__headerBtn",
  "headerContainer": "header-module-scss-module__4M_j_a__headerContainer",
  "headerFixed": "header-module-scss-module__4M_j_a__headerFixed",
  "headerMenu": "header-module-scss-module__4M_j_a__headerMenu",
  "headerOverlay": "header-module-scss-module__4M_j_a__headerOverlay",
  "headerUserActions": "header-module-scss-module__4M_j_a__headerUserActions",
  "headerWrp": "header-module-scss-module__4M_j_a__headerWrp",
  "isHeaderHidden": "header-module-scss-module__4M_j_a__isHeaderHidden",
  "isMenuLinkActive": "header-module-scss-module__4M_j_a__isMenuLinkActive",
  "isMobileMenu": "header-module-scss-module__4M_j_a__isMobileMenu",
  "logo": "header-module-scss-module__4M_j_a__logo",
  "menu": "header-module-scss-module__4M_j_a__menu",
  "menuBtn": "header-module-scss-module__4M_j_a__menuBtn",
  "menuIconLink": "header-module-scss-module__4M_j_a__menuIconLink",
  "menuLink": "header-module-scss-module__4M_j_a__menuLink",
  "menuLoginButton": "header-module-scss-module__4M_j_a__menuLoginButton",
  "menuLoginIcon": "header-module-scss-module__4M_j_a__menuLoginIcon",
  "mobileHeaderMenu": "header-module-scss-module__4M_j_a__mobileHeaderMenu",
  "mobileHeaderUserActions": "header-module-scss-module__4M_j_a__mobileHeaderUserActions",
  "tenantDealroadshow": "header-module-scss-module__4M_j_a__tenantDealroadshow",
  "wideMenuContainer": "header-module-scss-module__4M_j_a__wideMenuContainer",
});
